var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":"Photo de profil"},scopedSlots:_vm._u([{key:"card-title",fn:function(){return [_c('span',{staticClass:"card-title mb-16"},[_vm._v("Photo de profil")])]},proxy:true},{key:"card-content",fn:function(){return [_c('edit-photo-form')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }